import { useApi } from '@/api';
import { TableSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import {
  CryptoIcon,
  CurrencyValue,
  DataTable,
  EtherScanPictogram,
  Flex,
  Heading,
  WalletAddress,
  useTableProps,
  RelativeDateTime
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function MKREventsTable() {
  const { pagination, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });
  const [data, error] = useApi({
    url: '/migrations/mkr/events/',
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Wallet',
        getCell: (row) => (
          <WalletAddress
            address={row.wallet_address}
            options={{
              showCopyBtn: true,
              inline: true,
              sizes: { blockie: '0' }
            }}
          />
        ),
        columnSize: ['minmax(100px, auto)']
      },
      {
        header: 'Event',
        getCell: (row) => row.event,
        sortingField: 'event'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Amount
            <CryptoIcon name="MKR" size="0" />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue
            value={row.mkr_amount}
            options={{
              trend: true,
              iconSize: '-1'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'mkr_amount'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Amount
            <CryptoIcon
              name="SKY"
              address={tokensMapping('SKY').address}
              size="0"
            />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue
            value={row.sky_amount}
            options={{
              trend: true,
              iconSize: '-1'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'sky_amount'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Flex gap={['xs', '2xs']} color="muted">
            <RelativeDateTime value={row.datetime} />
            <a
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="0" />
            </a>
          </Flex>
        ),
        sortingField: 'order_index',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <>
        <Heading size="2">Events</Heading>
        <DataTable
          rows={data['results']}
          columns={columns}
          getKey={(row) => row.order_index}
          sorting={sorting}
          pagination={{
            ...pagination,
            totalRecords: data.count
          }}
        />
      </>
    );
  }
  return <TableSkeleton />;
}
